import React from "react";

function MoveBoxWrapper({
    children,
    toggleList,
    callConfirmChangeDrawerListSort,
    changeEditDrawerListToOriginalDrawerList,
}) {
    const handleClickCompleteButton = () => {
        callConfirmChangeDrawerListSort();
    };

    const handleClickCancleButton = () => {
        toggleList();
        changeEditDrawerListToOriginalDrawerList();
    };

    return (
        <div className="moveBox clear">
            <div className="moveBoxtext fr">
                <div className="fl report1" onClick={handleClickCancleButton}>
                    취소
                </div>
                <div className="fl report2" onClick={handleClickCompleteButton}>
                    완료
                </div>
            </div>
            {children}
        </div>
    );
}

export default MoveBoxWrapper;
